import CertinomisCard from './CertinomisCard';

export default CertinomisCard;
